import {
  STORE_RADIUS_MAX_M,
  STORE_RADIUS_MIN_M,
  STORE_RADIUS_PRESET_LABEL,
  type StoreRadiusPreset,
} from '@fewerbags/core';
import { Field } from '../Field';

const PRESETS: StoreRadiusPreset[] = ['normal', 'bigBox', 'custom'];

/**
 * Detection radius picker (PLAN §4.7): Normal 150 m, Big-box 300 m, or a custom
 * number of metres. The phone treats you as "at" the store inside this radius.
 */
export function RadiusField({
  idPrefix,
  preset,
  custom,
  onPresetChange,
  onCustomChange,
  error,
}: {
  idPrefix: string;
  preset: StoreRadiusPreset;
  custom: string;
  onPresetChange: (preset: StoreRadiusPreset) => void;
  onCustomChange: (value: string) => void;
  error?: string | undefined;
}) {
  return (
    <fieldset className="flex flex-col gap-2">
      <legend className="text-sm font-medium text-ink">Detection radius</legend>
      <div className="flex flex-wrap gap-2">
        {PRESETS.map((p) => (
          <label
            key={p}
            className={`flex min-h-11 cursor-pointer items-center gap-2 rounded-lg border px-3 text-sm ${
              preset === p ? 'border-brand bg-brand-soft text-brand' : 'border-line text-ink'
            }`}
          >
            <input
              type="radio"
              name={`${idPrefix}-radius`}
              value={p}
              checked={preset === p}
              onChange={() => onPresetChange(p)}
              className="size-4 accent-brand"
            />
            {STORE_RADIUS_PRESET_LABEL[p]}
          </label>
        ))}
      </div>
      {preset === 'custom' ? (
        <Field
          id={`${idPrefix}-radius-custom`}
          label="Radius in metres"
          type="number"
          inputMode="numeric"
          min={STORE_RADIUS_MIN_M}
          max={STORE_RADIUS_MAX_M}
          step={1}
          value={custom}
          onChange={(e) => onCustomChange(e.target.value)}
          error={error}
        />
      ) : null}
      <p className="text-xs text-muted">
        Big-box covers large stores and their car parks. Custom: {STORE_RADIUS_MIN_M}–
        {STORE_RADIUS_MAX_M} m.
      </p>
    </fieldset>
  );
}
